<template>
    <BreadCrumb PageTitle="Liste des Clients" />
    <ListeClient />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeClient from "../../components/Client/ListeClient.vue";

    export default defineComponent({
        name: "ListeClientPage",
        components: {
            BreadCrumb,
            ListeClient,
        },
    });
</script>